import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { UnderwayComponent } from './underway.component';
import { underwayRoutingoModule } from './underway-routing.module';
@NgModule({
  imports: [
    underwayRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [UnderwayComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class underwayModule { }
